<template>
  <div class="pogs-panel reports-panel">
    <header>
      <h3>Comparison Table</h3>
      <div class="smd-spacer"/>
      <smd-segment type="pill" :items="$options.Views"
                   v-model="activeView"
                   :value="activeView"/>
    </header>

    <div class="content">

      <div ref="table" class="reports-table">

        <table-column :fixed="true"
                      :dataPoints="lookupHeader"/>

        <div class="reports-table__wrapper" :style="{'width': offsetWidth ? offsetWidth + 'px' : 'initial'}">
          <div class="scrollable-container">

            <div>
              <div class="scrollable-content">
                <table-column :class="alignValues"
                              v-for="data in dataPoints"
                              :key="data.category"
                              :dataPoints="data"/>
              </div>
            </div>

          </div>

          <div class="fixed-column">
            <div class="reports-table__column" :class="alignValues">
              <header>
                <label dark>Total</label>
              </header>

              <div class="reports-table__cell" v-for="(total,index) in columnTotals" :key="index">
                <p>{{total | tableNullFormat }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions } from 'vuex'
  import { GETTER_TABLE_COLUMN_CATEGORY, GETTER_TABLE_ROW_CATEGORY, GETTER_TABLE_RESULT, ACTION_LOAD_TABLE_RESULT}
  from "../../../../store/modules/analytics-table";
  import TableColumn from './pogs-reports__table__column'
  import {transposeTable} from "../../../../utilities/reduceFunctions";

  const ACTIVEVIEW_VALUE = 'value';
  const ACTIVEVIEW_PERCENTAGE = 'percentage';

  const ifNull = (value, alternative) => (value !== null && value !== undefined) ? value : alternative;
  const percentageOf = (total) => (part) => total > 0 ? parseFloat(part / total * 100).toFixed(0) + "%" : "0%";

  export default {
    name: "pogs-reports__table",
    Views:[
      {val: ACTIVEVIEW_PERCENTAGE, label: 'Percentage'},
      {val: ACTIVEVIEW_VALUE     , label: 'Value'}
    ],
    props: {
      dateFilter: {type:Object, default: () => ({
          from : new Date().setMonth(new Date().getMonth() - 3),
          to : new Date()
        }) }
    },
    components: {TableColumn},
    computed:{
      ...mapGetters({
        row:GETTER_TABLE_ROW_CATEGORY,
        column:GETTER_TABLE_COLUMN_CATEGORY,
        resultTable:GETTER_TABLE_RESULT
      }),
      alignValues(){
        return this.activeView == ACTIVEVIEW_PERCENTAGE ? 'right-align' : undefined;
      },
      transposedResult() {
        if (this.resultTable)
          return transposeTable(this.resultTable)
        else
          return null
      },
      columnTotals() {
        if (!this.resultTable) return [];
        let rowTotals = this.resultTable.reduce( (acc,v) => {
          acc.totals.push( ifNull(v.acc, v.count) );
          acc.grandtotal = acc.grandtotal + ifNull(v.acc, v.count);
          return acc
        }, {totals:[],grandtotal:0});
        let percentageOfTotal = percentageOf(rowTotals.grandtotal)
        if (this.activeView === ACTIVEVIEW_PERCENTAGE) {
          rowTotals.totals = rowTotals.totals.map( (v) => percentageOfTotal(v));
          rowTotals.grandtotal = "100%"
        }

        return [rowTotals.grandtotal].concat(rowTotals.totals).concat([rowTotals.grandtotal]);
      },
      title(){
        return this.$route.params.filterBy
      },
      lookupHeader(){
        if (this.row && this.row.segments) {
          return {title: this.row.label, data: this.row.segments.reduce((acc, v)=> { acc.push({category:v.label}); return acc;}, [])};
        } else {
          return {title: "Select a category", data:[]}
        }
      },
      dataPoints() {
        // Base cases when no data is present
        if (!this.row) return [];
        if (!this.column) return [];
        if (!this.resultTable) return [];
        // Compute total
        let grandtotal = this.resultTable.reduce(
          (acc, v) => acc + (this.column.segments ? v.acc : v.count), 0);
        let percentageOfTotal = percentageOf(grandtotal);
        // No-cross Segments
        if (!this.column.segments) {
          let data = this.resultTable.reduce((rowacc, row) => {
            rowacc.push({
              category: row.label,
              total: this.activeView === ACTIVEVIEW_PERCENTAGE ? percentageOfTotal(row.count) : row.count
            });
            return rowacc;
          }, []);

          return [{
            colname: "Counts",
            total: this.activeView === ACTIVEVIEW_PERCENTAGE ? "100%" : grandtotal,
            data: data
          }];
        } else {
          // Cross segments
          let result = this.column.segments.map((col) => {
            let coldata = ifNull(this.transposedResult[col.name],{ acc:0, crosssegments:{} });
            let rowResult = this.row.segments.map((row) => {
              let value = ifNull(coldata.crosssegments[row.name], { count:0 }).count
              return {
                category: row.label,
                total: this.activeView === ACTIVEVIEW_PERCENTAGE ? percentageOfTotal(value) : value
              }
            });
            return {
              colname: col.label,
              total: this.activeView === ACTIVEVIEW_PERCENTAGE ? percentageOfTotal(coldata.acc) : coldata.acc,
              data: rowResult
            }
          });
          return result;
        }
      }
    },
    data(){
      return{
        activeView    : 'value',
        originalWidth : null,
        offsetWidth   : null
      }
    },
    methods: {
      ...mapActions({
        reloadTable:ACTION_LOAD_TABLE_RESULT
      }),
      reload(){
        this.reloadTable({category:this.row.name,cross: (this.column.name === "N/A") ? undefined : this.column.name,
          from:this.dateFilter.from.getTime(), to: this.dateFilter.to.getTime()});
        this.updateWidth();
      },
      updateWidth(){
        const cellWidth = (this.dataPoints.length + 1)* 140;

        if(cellWidth < this.originalWidth){
           this.offsetWidth = cellWidth;
        }else{
          this.offsetWidth = this.originalWidth;
        }
      },
    },
    watch: {
      row(newValue) {
        this.reloadTable({category:newValue.name,cross: (this.column.name === "N/A") ? undefined : this.column.name,
          from:this.dateFilter.from.getTime(), to: this.dateFilter.to.getTime()});
        this.updateWidth();
      },
      column(newValue) {
        this.reloadTable({category:this.row.name,cross: (newValue.name === "N/A") ? undefined : newValue.name,
          from:this.dateFilter.from.getTime(), to: this.dateFilter.to.getTime()});
        this.updateWidth();
      },
      dateFilter() {
        this.reload();
      },
      deep:true
    },
    mounted() {
      this.originalWidth = this.$refs['table'].getBoundingClientRect().width - 280;
      this.reload();
    }
  }
</script>

<style lang="scss">

  @import '../../../../scaffolding/scss/pogs-util';

  $cell-width  : 130px;
  $cell-height : 42px;

  %cell{
    @extend %flex-row--center-x, %border-bottom;
    padding: space(s) 0;
    min-height: $cell-height !important;

    &.disabled{
      @extend %user-no-select;
      color: color(disabled);
    }
  }

  %tooltip-support{
    & > .text{
      @extend %text-overflow-ellipsis, %user-no-select;
    }

    &:hover{
      overflow: visible;
      z-index: 1000;
    }
  }

  .reports-table{
    @include make-grid-cols(280px 1fr);
    margin: space(m) 0;

    header{
      @extend %cell;
    }
  }

  .fixed-labels{
    & > header{
      @extend %border-right;
      position: relative;
      margin-top: $cell-height;

      &:after{
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        top: -1px;
        right: -11px;
        background: white;
        border-top: 1px solid color(base, border);
        border-left: 1px solid color(base, border);
        border-top-left-radius: radius(normal);
        z-index: 1003;
      }

      &:before{
        z-index: 1001;
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        top: -1px;
        right: -5px;
        background: white;
      }
    }

    & > section{
      @extend %border-right;

      & > header,
      .dark{
        position: relative;
        padding-left: space(m);
        max-height: $cell-height;

        p{
          @extend %flex-row--center-x, %tooltip-support;
          .text{max-width: 260px;}
        }
      }

      & > .reports-table__cell:not(.dark) {
        padding-left: space(l);
      }
    }
  }

  .reports-table__cell{
    @extend %cell;
    min-width: $cell-width;

    &.dark{
      font-weight: font(medium-bold);
    }
  }

  .reports-table__column{
    flex: 1;

    & > header{
      justify-content: center !important;

      label{
        @extend %text-overflow-ellipsis;
        max-width: $cell-width;
        padding: 0 space(xs);
      }
    }

    &.left-align{
      .reports-table__cell{
        justify-content: flex-end;
        padding-right: 42%;
      }
    }

    &.right-align{
      .reports-table__cell{
        justify-content: flex-start;
        padding-left: 40%;
      }
    }

    .reports-table__cell{
      justify-content: center;
    }

    & .reports-table__cell{
      @extend %border-left;
    }

  }

  .reports-table__wrapper{
    @include make-grid-cols(1fr auto);
    @include transition(height 0.5s cubic-bezier(.17,.67,.84,.71));
  }

  .scrollable-container{
    @extend %independent-layout-container, %border-bottom;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .scrollable-content{
    @extend %independent-layout, %flex;
    margin-left: -1px;
  }

  .fixed-column{
    height: 100%;
    background: color(light, light-bg);

    font-weight: font(medium-bold);

    label[dark]{
      color: color(dark);
    }

    .reports-table__cell{
      @extend %border-right;

      &:last-child{
        background: darken(color(light,light-bg), 10);
      }
    }

    header{
      position: relative;

      &:after{
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        bottom: -11px;
        right: 0px;
        background: color(light, light-bg);
        border-top: 1px solid color(base, border);
        border-right: 1px solid color(base, border);
        border-top-right-radius: radius(normal);
        z-index: 1003;
      }

      &:before{
        z-index: 1001;
        content: ' ';
        height: 11px;
        width: 11px;
        position: absolute;
        bottom: -10px;
        right: 0px;
        background: color(light, light-bg);
      }
    }
  }

  @include responsive(mobile) {
    .reports-panel .smd-segment{
      flex-wrap: nowrap;
    }
    .page header p {
      width: auto;
    }
  }
</style>
